<template>
  <div class="container page-global">
    <section class="about-content">
      <h1>About Cashless FYI</h1>
      <p class="tagline">An educational front door for cashless programs in healthcare, senior living, and corporate dining.</p>
      <p class="details">
        Cashless FYI is a neutral, industry-focused resource. Free ROI calculators help operators understand the
        financial impact of cashless programs—cost savings, participation, and payback—before they ever talk to a vendor.
      </p>
      <p class="details">
        This site is provided by
        <a href="https://www.newcare.io" target="_blank">Newcare</a>, a platform heavily focused on resident and employee commerce.
        We separate the <strong>education</strong> (Cashless FYI) from the <strong>solution</strong> (Newcare) so you can
        explore ROI, assumptions, and trade‑offs without feeling like you walked into a sales pitch.
      </p>
      <p class="details">
        For feedback on the tools, suggestions for new calculators, or content updates, please email
        <a href="mailto:updates@cashless.fyi?subject=cashless.fyi Website Updates">updates@cashless.fyi</a>.
      </p>
      <hr class="divider" />
      <p class="powered-by">
        A resource provided by the industry data team at
        <a href="https://www.newcare.io" target="_blank">Newcare</a>.
      </p>
      <p class="footer-note">
        © {{ currentYear }} <a href="https://www.cashless.fyi" target="_blank">Cashless FYI</a>, All Rights Reserved :: Version {{ $root.appVersion }}
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "About",
  computed: {
    currentYear() {
      return new Date().getFullYear(); // Cleaner way to get current year
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/app.scss';

.about-content {
  padding: 4rem 0;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

h1 {
  font-size: 2.5rem;
  font-weight: 800;
  color: $body-color;
  margin-bottom: 1.5rem;
}

.tagline {
  font-size: 1.3rem;
  text-align:left;
  color: $secondary;
  margin-bottom: 2rem;
}

.details {
  text-align:left;
  font-size: 1.1rem;
  color: rgba($body-color, 0.9);
  margin-bottom: 2rem;
  line-height: 1.6;

  a {
    color: $primary;
    text-decoration: none;

    &:hover {
      color: lighten($primary, 10%);
      text-decoration: underline;
    }
  }
}

.divider {
  border-color: rgba($body-color, 0.2);
  margin: 2rem 0;
}

.powered-by {
  font-size: 0.9rem;
  color: rgba($body-color, 0.7);
  margin-bottom: 1rem;

  a {
    color: $primary;
    text-decoration: none;

    &:hover {
      color: lighten($primary, 10%);
      text-decoration: underline;
    }
  }
}

.footer-note {
  font-size: 0.9rem;
  color: $secondary;

  a {
    color: $primary;
    text-decoration: none;

    &:hover {
      color: lighten($primary, 10%);
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .about-content {
    padding: 2rem 0;
  }

  h1 {
    font-size: 2rem;
  }

  .tagline {
    font-size: 1.1rem;
  }

  .details {
    font-size: 1rem;
  }

  .footer-note {
    font-size: 0.8rem;
  }
}
</style>

